import {
  CustomDivider,
  StatusLayout,
  StyledButtonLayout,
  StyledDate,
  StyledStatus,
  StyledStatusName,
} from '@/components/Approval/RightContainer/ApprovalContent/styles';
import { strDate, strStatus } from '@/utils/function';
import React from 'react';
import { Approval, Author } from '@/types/api';
import { t } from 'i18next';
import { getApprovalDocUrl } from '@/utils/urls';
import AuthorInfo from '@/components/Approval/RightContainer/ApprovalContent/AuthorInfo';
import TitleInfo from '@/components/Approval/RightContainer/ApprovalContent/TitleInfo';
import AuthorAt from '@/components/Approval/RightContainer/ApprovalContent/AuthorAt';
import BookMarkButton from '@/components/Approval/RightContainer/ApprovalContent/BookMarkButton';
import { useWorkEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { EventPageAreaName, WorkEventName } from '@/constant/gtm';
import { parseStringFormatted } from '@/utils/format';

type P = {
  handleOpen(docId: string, approvalType?: string): void;
  handleBookMark(docId: string): void;
};

const ApprovalContent = ({
  handleOpen: _handleOpen,
  handleBookMark,
  ...approval
}: Approval & P) => {
  const {
    type,
    subject,
    author,
    status,
    currentApprover,
    docId,
    commentCount,
    opinionCount,
    authoredAt,
    updatedAt,
    createdAt,
    lastOpinionBy,
    latestComment,
    isBookmark,
  } = approval;
  const workEventTracker = useWorkEventTracker(EventPageAreaName.WORK_APPROVAL);

  const handleOpen = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // GA Work - Approval 2번
    workEventTracker(WorkEventName.viewWork, {
      area_name: 'Approval 목록',
      post_title: subject,
      post_category: type.name,
      creator: `${author.name} ${author.positionName}`,
      contents_id: docId,
    });

    if (e.ctrlKey || e.metaKey) return;
    e.preventDefault();
    e.stopPropagation();
    _handleOpen(docId, String(type.code));
  };

  const onClickAuthor = (author: Author) => {
    // GA Work - Approval 3번
    workEventTracker(WorkEventName.viewProfile, {
      area_name: 'Approval 목록',
      employees: `${author.name} ${author.positionName}`,
    });
  };

  return (
    <>
      <StyledButtonLayout
        href={getApprovalDocUrl(docId)}
        onClick={(e) => handleOpen(e)}
        draggable={false}
        target="blank"
        rel="noopener noreferrer"
      >
        <TitleInfo
          type={type}
          subject={subject}
          commentCount={commentCount}
          opinionCount={opinionCount}
          lastOpinionBy={lastOpinionBy}
          latestComment={latestComment}
        />
        <div style={{ marginLeft: '16px' }}>
          <AuthorInfo author={{ ...author }} onClick={onClickAuthor} />
        </div>
        <StatusLayout>
          <StyledStatus
            style={{
              color: strStatus(t, status).color,
              borderColor: strStatus(t, status).borderColor,
              backgroundColor: strStatus(t, status).backgroundColor,
            }}
          >{`${strStatus(t, status).title}`}</StyledStatus>
          <StyledStatusName>
            {currentApprover?.type === 2
              ? t('협조결재')
              : currentApprover
              ? currentApprover.name
              : '-'}
          </StyledStatusName>
          <StyledDate>
            {(status === 'R' || status === 'C') &&
              parseStringFormatted(updatedAt)}
          </StyledDate>
        </StatusLayout>
        <AuthorAt
          authoredAt={strDate(
            t,
            // 임시저장은 authoredAt 이 실제 수정일과 불일치 — updatedAt 표시, createdAt 폴백
            status === 'S' ? updatedAt ?? createdAt : authoredAt ?? createdAt,
          )}
          isModify={status === 'S'}
        />
        <BookMarkButton
          isBookMark={isBookmark}
          handleClick={() => {
            handleBookMark(docId);
            // GA Work - Approval 4번
            workEventTracker(WorkEventName.clickPostAction, {
              area_name: 'Approval 목록',
              post_title: subject,
              action_type: '북마크',
              post_category: type.name,
              contents: subject,
              contents_id: docId,
              status: !isBookmark,
            });
          }}
        />
      </StyledButtonLayout>
      <CustomDivider />
    </>
  );
};

export default ApprovalContent;
